import { render, staticRenderFns } from "./Capacprioridad.vue?vue&type=template&id=5a996bd3&scoped=true&"
import script from "./Capacprioridad.vue?vue&type=script&lang=js&"
export * from "./Capacprioridad.vue?vue&type=script&lang=js&"
import style0 from "./Capacprioridad.vue?vue&type=style&index=0&id=5a996bd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a996bd3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VApp,VCard,VCardTitle,VDataTable,VIcon})
